var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { reqProductRelation } from "../request/mtdsretail/linkage/productRelation/post.js";
import { reqSelectOrgMarketManageRightByFictitiousShopId } from "../request/ucenterapi/internal/org/selectOrgMarketManageRightByFictitiousShopId/get.js";
import { getProductDetail } from "./getUnifySelectDetailByIds.js";
import { opGetMarketRightDetail } from "../request/ucenterapi/internal/business/marketRightDetail/get.js";
function getUnifySelectAttr(item, key) {
  var _a;
  const modelAttribute = (_a = item.attributes) == null ? void 0 : _a.find((a) => a.attributeCode === key);
  if (modelAttribute)
    return modelAttribute;
  return void 0;
}
const getUnifySelectAttrValue = (item, key) => {
  var _a;
  const modelAttribute = getUnifySelectAttr(item, key);
  if (modelAttribute == null ? void 0 : modelAttribute.attributeValues)
    return (_a = modelAttribute.attributeValues) == null ? void 0 : _a.join(",");
  return "";
};
function getUnifySelectInventorySingle(arg) {
  const { details, product } = arg;
  const detail = details.find((d) => d.id === product.productId);
  return __spreadProps(__spreadValues({}, detail), {
    lineNo: product.lineNo,
    quantity: product.quantity,
    commodityId: product.productId,
    paramConfig: JSON.parse(product.extraFields),
    baseInfo: detail.commodity,
    no: detail.product.no
  });
}
async function getUnifySelectInventory(products) {
  const ids = products.reduce((ids2, product) => {
    if (product.isPackage && product.packageId) {
      ids2.push(product.packageId);
    }
    ids2.push(product.productId);
    return ids2;
  }, []);
  const details = await getProductDetail(ids);
  return products.reduce((p, c) => {
    var _a;
    if (c.isPackage) {
      const packageDetail = p.find((p2) => p2.commodityId === c.packageId);
      if (packageDetail) {
        (_a = packageDetail.items) == null ? void 0 : _a.push(getUnifySelectInventorySingle({ details, product: c }));
      } else {
        const detail = details.find((d) => d.id === c.packageId);
        p.push(__spreadProps(__spreadValues({}, detail), {
          lineNo: c.lineNo,
          quantity: c.quantity,
          commodityId: c.packageId,
          paramConfig: JSON.parse(c.extraFields),
          baseInfo: detail.commodity,
          no: detail.product.no,
          items: [getUnifySelectInventorySingle({ details, product: c })]
        }));
      }
    } else {
      p.push(getUnifySelectInventorySingle({ details, product: c }));
    }
    return p;
  }, []);
}
async function getUnifySelectData(arg) {
  var _a;
  const { unifySelectData, searchOptionClassify1 } = arg;
  unifySelectData.searchOption;
  const [marketManageRight, productRelationList] = await Promise.all([
    arg.searchOptionsMarketClassify ? reqSelectOrgMarketManageRightByFictitiousShopId(arg.searchOptionsMarketClassify) : void 0,
    arg.searchOptionClassify1 ? reqProductRelation(arg.searchOptionClassify1) : void 0
  ]);
  const ret = __spreadProps(__spreadValues({}, unifySelectData), {
    searchOption: __spreadProps(__spreadValues({}, unifySelectData.searchOption), {
      attributeCon: []
    })
  });
  if (marketManageRight) {
    ret.searchOption.marketClassify = marketManageRight.orgBelongMarketClassify;
  }
  if (productRelationList) {
    const classify1 = productRelationList == null ? void 0 : productRelationList.reduce((p, c) => {
      p ? p = p + `,${c.classify1}` : p = c.classify1;
      return p;
    }, "");
    (_a = ret.searchOption.attributeCon) == null ? void 0 : _a.push({
      attributeValues: classify1.split(","),
      attributeCode: "classify1",
      searchType: "EQ"
    });
  }
  return ret;
}
async function getUnifySelectDataV2(arg) {
  var _a;
  const { unifySelectData, searchOptionClassify1 } = arg;
  unifySelectData.searchOption;
  const [marketRightDetailRes, productRelationList] = await Promise.all([
    arg.searchOptionsMarketClassify ? opGetMarketRightDetail(arg.searchOptionsMarketClassify) : void 0,
    arg.searchOptionClassify1 ? reqProductRelation(arg.searchOptionClassify1) : void 0
  ]);
  const ret = __spreadProps(__spreadValues({}, unifySelectData), {
    searchOption: __spreadProps(__spreadValues({}, unifySelectData.searchOption), {
      attributeCon: []
    })
  });
  const marketRightDetailData = (marketRightDetailRes == null ? void 0 : marketRightDetailRes.data) || null;
  if (marketRightDetailData && marketRightDetailData.length > 0) {
    const { orgBelongMarketClassify } = marketRightDetailData[0];
    ret.searchOption.marketClassify = orgBelongMarketClassify;
  }
  if (productRelationList) {
    const classify1 = productRelationList == null ? void 0 : productRelationList.reduce((p, c) => {
      p ? p = p + `,${c.classify1}` : p = c.classify1;
      return p;
    }, "");
    (_a = ret.searchOption.attributeCon) == null ? void 0 : _a.push({
      attributeValues: classify1.split(","),
      attributeCode: "classify1",
      searchType: "EQ"
    });
  }
  return ret;
}
function getCheckFromUnifySelectInventory(inventory) {
  return inventory.reduce((p, i) => {
    var _a, _b, _c, _d, _e;
    let id = 0;
    if (i.baseInfo.combination) {
      const { paramConfig } = i;
      (_a = i.items) == null ? void 0 : _a.forEach((it) => {
        const extraFields = Object.assign({}, paramConfig, it.paramConfig);
        p.push({
          extraFields: JSON.stringify(extraFields),
          faucetModel: extraFields.faucetModel || getUnifySelectAttrValue(it, "faucetModel"),
          installationMode: extraFields.installationMode || getUnifySelectAttrValue(it, "installationMode"),
          isPackage: 1,
          lineNo: i.lineNo || "",
          packageId: i.commodityId,
          packageSize: `${i.quantity}`,
          packagetype: extraFields.packageType || getUnifySelectAttrValue(i, "packageType"),
          price: it.baseInfo.standardPrice,
          productId: it.commodityId,
          productionMode: it.baseInfo.productionMode,
          quantity: it.quantity,
          specification: getUnifySelectAttrValue(it, "specification"),
          standard: extraFields.isNonStand || getUnifySelectAttrValue(it, "isNonStand"),
          unionCode: it.baseInfo.name,
          id: `${id++}`
        });
      });
    } else {
      p.push({
        extraFields: JSON.stringify(i.paramConfig),
        faucetModel: ((_b = i.paramConfig) == null ? void 0 : _b.faucetModel) || getUnifySelectAttrValue(i, "faucetModel"),
        installationMode: ((_c = i.paramConfig) == null ? void 0 : _c.installationMode) || getUnifySelectAttrValue(i, "installationMode"),
        isPackage: 0,
        lineNo: i.lineNo || "",
        packageId: "",
        packageSize: ``,
        packagetype: ((_d = i.paramConfig) == null ? void 0 : _d.packageType) || getUnifySelectAttrValue(i, "packageType"),
        price: i.baseInfo.standardPrice,
        productId: i.commodityId,
        productionMode: i.baseInfo.productionMode,
        quantity: i.quantity,
        specification: getUnifySelectAttrValue(i, "specification"),
        standard: ((_e = i.paramConfig) == null ? void 0 : _e.isNonStand) || getUnifySelectAttrValue(i, "isNonStand"),
        unionCode: i.baseInfo.name,
        id: `${id++}`
      });
    }
    return p;
  }, []);
}
function isCaxaInventory(item) {
  var _a;
  return (_a = item.tagList) == null ? void 0 : _a.includes("\u8BBE\u8BA1\u8F6F\u4EF6");
}
export { getCheckFromUnifySelectInventory, getUnifySelectAttr, getUnifySelectAttrValue, getUnifySelectData, getUnifySelectDataV2, getUnifySelectInventory, isCaxaInventory };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getUnifySelectData.js